import { useQuery } from '@tanstack/react-query';
import api from '../utils/axios.config';
import { baseUrl } from '../utils/url';

const useLogo = () => {
  return useQuery({
    queryKey: ['logoSetting'],
    queryFn: async () => {
      const response = await api.get('/setting/logo');
      return response.data.data;
    },
    select: (data) => {
      if (data?.imageUrl) {
        return `${baseUrl}${data.imageUrl}`;
      }
      return null; // No logo set yet
    },
    retry: false, // Don't retry on failure
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};

export default useLogo;
